import Route from "../../../router/Route";
import { RouterView, RouteLocationNormalized } from "vue-router";

import Overview from "../pages/Overview.vue";
import EditOverview from "../pages/Edit.vue";
import PermissionTab from "@/modules/users/components/PermissionTab.vue";
import GeneralSettingsTab from "@/modules/users/components/GeneralSettingsTab.vue";
import ApiTokensTab from "@/modules/users/components/ApiTokens.vue";
import NotificationPreference from "@/modules/users/components/NotificationPreference.vue";
import NotificationEvents from "@/modules/users/components/NotificationEvents.vue";

export default new Route("users", "/users", RouterView, [
	new Route("users.index", "", Overview, []),
	new Route(
		"users.edit",
		"edit/:uuid",
		EditOverview,
		[
			new Route("users.edit.permissions", "permissions", PermissionTab, []),
			new Route(
				"users.edit.notification.events",
				"notification-events",
				NotificationEvents,
				[]
			),
			new Route(
				"users.edit.notification.preference",
				"notification-preference",
				NotificationPreference,
				[]
			),
			new Route("users.edit.api_tokens", "api-tokens", ApiTokensTab, []),
			new Route(
				"users.edit.general",
				"general-settings",
				GeneralSettingsTab,
				[]
			),
		],
		{},
		(to: RouteLocationNormalized): string => {
			return `/users/edit/${to.params.uuid}/general-settings`;
		}
	),
]);
